export const TECKENVAND_KOLUMN = 'Teckenvänd kolumn';
export const ANALYSKATEGORI_ID_VISA_SAMMANFATTNING = -130;
export const LEVEL_VERKSAMHETSNIVA = 'Verksamhetsnivå';
//Behövs för att man borrar från verksamhetsområde till verksamhet i sammanfattningstabellen
export const VERKSAMHETSOMRADE_SAKNAS = 'Verksamhetsområde saknas';
//Behövs för att man ska göra urval på att verksamhet saknar värde
export const VERKSAMHET_SAKNAS = 'Verksamhet saknas';
export const VERKSAMHET_BENAMNING = 'Verksamhet';

export const MISSING_VALUE_IN_KODDEL = 'saknas';
export const MISSING_VALUE_IN_KODDEL_URL = 'saknarVarde';

export const KOSTNADSUPPFOLJNING_IDKOD = 'DET001';
export const INTAKTSUPPFOLJNING_IDKOD = 'DET002';
export const RESULTATUPPFOLJNING_IDKOD = 'DET003';

export enum AnalysLevelEnum {
  MIDDLE,
  LAST,
  UNSET,
}

export enum DetaljStatusEnum {
  ABOVE = 'above',
  BELOW = 'below',
  EQUAL = 'equal',
}

export const RadioBarChartSortByOptionsEnum = {
  BENAMNING: 'benamning',
  UTFALLASC: 'utfallAsc',
  UTFALLDESC: 'utfallDesc',
  BUDGETASC: 'budgetAsc',
  BUDGETDESC: 'budgetDesc',
};

export enum AnalysTypeEnum {
  KOSTNADSUPPFOLJNING,
  INTAKTSUPPFOLJNING,
  RESULTATUPPFOLJNING,
  UNDEFINEDUPPFOLJNING,
}

export enum PrevColumnTypeEnum {
  CURRENT_YEAR,
  PREVIOUS_YEAR,
}

export enum SpecifikationTypeEnum {
  KOSTNAD = 'K',
  INTAKT = 'I',
  UNDEFINED = 'U',
}

export const UTGAENDE_VARDE_LABEL = 'Utgående värde period';
export const BUDGET_RIKTVARDE_LABEL = 'Budget riktvärde period';
export const UTGAENDE_VARDE_LAST_YEAR_LABEL = 'Utgående värde period fg år';
export const MAX_PIE_CHART_LEGEND_COUNT = 18;
